import React, { useEffect, useState, useRef } from 'react';
import { logo } from '../component/ImageList';
import { Link, useNavigate } from 'react-router-dom';
import baseURL from '../component/baseURL';
import { ReactNotifications, Store } from 'react-notifications-component';
import showNotification from '../component/Notification';
import 'animate.css';

export default function Login({ transferProps }) {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isCodePopupOpen, setIsCodePopupOpen] = useState(false);
    const [agentKey, setAgentCode] = useState(['', '', '', '', '', '']);
    const codeInputRefs = useRef([]);

    useEffect(() => {
        const userID = localStorage.getItem('userID');
        const agentKey = localStorage.getItem('agentKey');

        // If both userID and agentKey exist, navigate to home page
        if (userID && agentKey) {
            navigate('/home');
        }
    }, [navigate]);



    function loginApi() {


        let formdata = new FormData();
        formdata.append("key", '81dc9bdb52d04dc20036dbd8313ed055')
        formdata.append("username", email)
        formdata.append("password", password)
        fetch(baseURL.URL + '/consumers/login', {
            method: 'POST',
            body: formdata
        }).then((response) => response.json())
            .then((responseJson) => {

                console.log('LOGIN API RESPONSE-------------------------');
                console.log(responseJson);
                const myResponse = responseJson.response;
                if (responseJson.server.result_code === 200) {
                    // Show six-digit code popup after successful login
                    setIsCodePopupOpen(true);
                    localStorage.setItem('userID', responseJson.response.user_id);
                }
                else {
                    // Toast.showWithGravity(responseJson.server.message, Toast.SHORT, Toast.BOTTOM)
                    showNotification('Error', responseJson.server.message, 'danger');
                }
            })
            .catch((error) => {
                console.error(error);
                showNotification('Error', 'Something went wrong', 'danger');
            });
    }


    function addAgentCodeApi(agentKey) {

        let formdata = new FormData();
        formdata.append("key", '81dc9bdb52d04dc20036dbd8313ed055')
        formdata.append("user_id", localStorage.getItem('userID'))
        formdata.append("agent_key", agentKey)
        fetch(baseURL.URL + '/consumers/agent_details', {
            method: 'POST',
            body: formdata
        }).then((response) => response.json())
            .then((responseJson) => {
                console.log('ADD AGENT CODE API RESPONSE-------------------------');
                console.log(responseJson);
                if (responseJson.server.result_code === 200) {
                    //   this._storeAgentKey(aID)
                    //   this.setState({ modalView: false ,result:responseJson.server.response})
                    localStorage.setItem('agentKey', agentKey);
                    localStorage.setItem('firstName', responseJson.server.response.fname);
                    localStorage.setItem('lastName', responseJson.server.response.lname);
                    navigate('/home');
                    showNotification('Success', 'Agent code added successfully', 'success');
                }
                else if (responseJson.server.result_code === 500) {
                    //   this.startShake()
                    // Show error notification
                    showNotification('Error', responseJson.server.message, 'danger');
                }
                else {
                    //   this.startShake()
                    console.log(responseJson.server.result_code)
                    showNotification('Error', 'Something went wrong', 'danger');
                }
            })
            .catch((error) => {
                console.error(error);
                showNotification('Error', 'Something went wrong', 'danger');
            });
    }

    const openCodePopup = () => {
        setIsCodePopupOpen(true);
        // Focus first input when popup opens
        setTimeout(() => {
            if (codeInputRefs.current[0]) {
                codeInputRefs.current[0].focus();
            }
        }, 100);
    };

    const closeCodePopup = () => {
        setIsCodePopupOpen(false);
        setAgentCode(['', '', '', '', '', '']);
    };

    const handleCodeChange = (index, value) => {
        // Only allow single digit
        if (value.length > 1) return;

        // Only allow numbers
        if (value && !/^\d$/.test(value)) return;

        const newCode = [...agentKey];
        newCode[index] = value;
        setAgentCode(newCode);

        // Auto-focus next input if value entered
        if (value && index < 5) {
            codeInputRefs.current[index + 1]?.focus();
        }
    };

    const handleCodeKeyDown = (index, e) => {
        // Handle backspace
        if (e.key === 'Backspace' && !agentKey[index] && index > 0) {
            codeInputRefs.current[index - 1]?.focus();
        }
    };

    const handleCodePaste = (e) => {
        e.preventDefault();
        const pastedData = e.clipboardData.getData('text').trim();
        if (/^\d{6}$/.test(pastedData)) {
            const newCode = pastedData.split('').slice(0, 6);
            setAgentCode(newCode);
            // Focus last input
            codeInputRefs.current[5]?.focus();
        }
    };

    const handleSubmitCode = () => {
        const codeString = agentKey.join('');
        if (codeString.length === 6) {
            console.log('Submitted code:', codeString);
            addAgentCodeApi(codeString);
            closeCodePopup();
        }
    };

    const handleCancelCode = () => {
        closeCodePopup();
    };



    return (
        <>
            <ReactNotifications />
            <section className="login-section">
                <div className='login-holder'>
                    <figure className='logo-holder mb-4'>
                        <img src={logo} alt="logo" />
                    </figure>
                    <div className='login-form text-center'>
                        <h2 className='form-title text-black'>Welcome Back!</h2>
                        <p className='form-description text-black'>Please log in to your account to continue.</p>
                        <div>
                            <div className='form-group mb-3'>

                                <input className='form-control ' type='email' id='email' name='email' placeholder='Enter your email' value={email} onChange={(e) => setEmail(e.target.value)} />
                            </div>
                            <div className='form-group mb-3'>

                                <input className='form-control ' type='password' id='password' name='password' placeholder='Enter your password' value={password} onChange={(e) => setPassword(e.target.value)} />
                            </div>
                            <div className='form-group mb-3 text-end'>
                                <Link to='/forgot-password' className='text-decoration-none text-black text-sm'>Forgot Password?</Link>
                            </div>
                            <button type='submit' className='btn save-btn w-100' onClick={() => loginApi()}>Login</button>
                        </div>
                        <div className='signup-sec mt-6'>
                            <p className='text-black text-sm'>Don't have an account? <Link to='/signup' className='text-decoration-none text-black text-sm border-b border-b-black'>Sign up</Link></p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Six Digit Code Popup */}
            {isCodePopupOpen && (
                <div className={`code-popup-modal ${isCodePopupOpen ? 'is-open' : 'is-open'}`}>
                    <div className="code-popup-modal-overlay" onClick={handleCancelCode}></div>
                    <div className="code-popup-modal-content">
                        <div className="code-popup-modal-header text-center">
                            <h3 className="code-popup-modal-title">Enter Agent Code</h3>
                        </div>
                        <div className="code-popup-modal-body">
                            <p className="code-popup-description">Please enter the 6-digit agent code</p>
                            <div className="code-input-container">
                                {agentKey.map((digit, index) => (
                                    <input
                                        key={index}
                                        ref={(el) => (codeInputRefs.current[index] = el)}
                                        type="text"
                                        inputMode="numeric"
                                        maxLength="1"
                                        className="code-input"
                                        value={digit}
                                        onChange={(e) => handleCodeChange(index, e.target.value)}
                                        onKeyDown={(e) => handleCodeKeyDown(index, e)}
                                        onPaste={handleCodePaste}
                                        autoComplete="off"
                                    />
                                ))}
                            </div>
                        </div>
                        <div className="code-popup-modal-actions">
                            <button className="btn btn-secondary" onClick={handleCancelCode}>
                                Cancel
                            </button>
                            <button
                                className="btn save-btn"
                                onClick={handleSubmitCode}
                                disabled={agentKey.join('').length !== 6}
                            >
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}